import { all, fork } from "redux-saga/effects";

import { activityAnnotationSaga } from "./activity/ActivityAnnotation/store/saga";
import { addToRouteModalSaga } from "./AddToRouteModal/store/saga";
import { entityAssociationsSaga } from "./associations/store/saga";
import { createEditActivityModalSaga } from "./createEditEntity/Activity/store/saga";
import { addNoteModalSaga } from "./createEditEntity/AddNoteModal/store/saga";
import { createCompanyModalSaga } from "./createEditEntity/CreateCompanyModal/store/saga";
import { createDealModalSaga } from "./createEditEntity/CreateDealModal/store/saga";
import { createPersonModalSaga } from "./createEditEntity/CreatePersonModal/store/saga";
import { editStageModalSaga } from "./createEditEntity/EditStageModal/store/saga";
import { dataViewSaga } from "./DataView/store/saga";
import { entityAnnotationSagas } from "./EntityAnnotation/store/sagas";
import { entityEmailsSaga } from "./EntityEmails/store/saga";
import { entityHistorySaga } from "./EntityHistoryModal/store/saga";
import { entityMentionsSaga } from "./EntityMentions/store/saga";
import { filePreviewSaga } from "./FilePreview/store/saga";
import { userLocationRequestSaga } from "./Layout/components/UserLocationRequest/saga";
import { leadFinderSagas } from "./leadFinder/store/sagas";
import { multiPinSagas } from "./map/domains/entities/drawer/store/sagas";
import { navigationBarSaga } from "./NavigationBar/store/saga";
import { postCreationSaga } from "./PostCreationModal/store/saga";
import { activityRecordSaga } from "./preview/ActivityRecordPane/store/saga";
import { companyRecordSaga } from "./preview/CompanyRecordPane/store/saga";
import { dealRecordSaga } from "./preview/DealRecordPane/store/saga";
import { personRecordSaga } from "./preview/PersonRecordPane/store/saga";
import { dealsSaga } from "./PreviewDealsListModal/store/saga";
import { tripModalSaga } from "./tripModal/store/saga";
import { userPreviewCardSaga } from "./UserPreviewCard/store/saga";
import { selectBarSaga } from "./view/SelectBar/store/saga";

export function* componentSaga() {
  yield all([
    fork(activityAnnotationSaga),
    fork(activityRecordSaga),
    fork(addNoteModalSaga),
    fork(addToRouteModalSaga),
    fork(companyRecordSaga),
    fork(createCompanyModalSaga),
    fork(createDealModalSaga),
    fork(createEditActivityModalSaga),
    fork(createPersonModalSaga),
    fork(dataViewSaga),
    fork(dealRecordSaga),
    fork(dealsSaga),
    fork(editStageModalSaga),
    fork(entityAnnotationSagas),
    fork(entityAssociationsSaga),
    fork(entityHistorySaga),
    fork(entityEmailsSaga),
    fork(entityMentionsSaga),
    fork(filePreviewSaga),
    fork(leadFinderSagas),
    fork(multiPinSagas),
    fork(navigationBarSaga),
    fork(personRecordSaga),
    fork(postCreationSaga),
    fork(selectBarSaga),
    fork(tripModalSaga),
    fork(userLocationRequestSaga),
    fork(userPreviewCardSaga),
  ]);
}
